enum StudyTabEnum {
  ANALYSIS = 'ANALYSIS',
  FILES = 'FILES',
  REPORTS = 'REPORTS',
  SETTINGS = 'SETTINGS',
}

export default StudyTabEnum;
